
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/terms",
      function () {
        return require("private-next-pages/site/terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/terms"])
      });
    }
  